import React, { useState, useEffect } from 'react';
import './RoomNameModal.css';

const RoomNameModal = ({ isOpen, onClose, onSave, currentName = '', roomId }) => {
  const [selectedName, setSelectedName] = useState(currentName);
  const [customName, setCustomName] = useState(currentName);
  const [showCustomInput, setShowCustomInput] = useState(false);

  // Predefined room names
  const predefinedNames = [
    'Living Room',
    'Bedroom',
    'Master Bedroom',
    'Kitchen',
    'Dining Room',
    'Bathroom',
    'Master Bathroom',
    'Office',
    'Study',
    'Family Room',
    'Game Room',
    'Home Theater',
    'Gym',
    'Laundry Room',
    'Mudroom',
    'Foyer',
    'Hallway',
    'Closet',
    'Pantry',
    'Garage',
    'Basement',
    'Attic',
    'Sunroom',
    'Den',
    'Library',
    'Music Room',
    'Art Studio',
    'Guest Room',
    'Nursery',
    'Kids Room',
    'Teen Room',
    'Man Cave',
    'She Shed',
    'Home Office',
    'Workshop',
    'Storage Room',
    'Utility Room',
    'Wine Cellar',
    'Home Bar',
    'Breakfast Nook',
    'Conservatory',
    'Solarium',
    'Loggia',
    'Veranda',
    'Porch',
    'Deck',
    'Patio'
  ];

  useEffect(() => {
    setSelectedName(currentName);
    setCustomName(currentName);
    setShowCustomInput(false);
  }, [currentName, isOpen]);

  const handleNameSelect = (name) => {
    setSelectedName(name);
    setCustomName(name);
    setShowCustomInput(false);
  };

  const handleCustomNameChange = (e) => {
    const value = e.target.value;
    setCustomName(value);
    setSelectedName(value);
  };

  const handleSave = () => {
    onSave(selectedName);
    onClose();
  };

  const handleCancel = () => {
    setSelectedName(currentName);
    setCustomName(currentName);
    setShowCustomInput(false);
    onClose();
  };

  const filteredNames = predefinedNames.filter(name =>
    name.toLowerCase().includes(customName.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="room-name-modal-overlay">
      <div className="room-name-modal">
        <h3>Name Room</h3>
        <div className="room-name-input">
          <input
            type="text"
            value={customName}
            onChange={handleCustomNameChange}
            placeholder="Type to search or enter custom name..."
            className="name-input"
            autoFocus
          />
        </div>
        
        <div className="name-suggestions">
          {filteredNames.length > 0 && customName.length > 0 ? (
            <div className="suggestions-list">
              {filteredNames.slice(0, 10).map((name, index) => (
                <div
                  key={index}
                  className={`suggestion-item ${selectedName === name ? 'selected' : ''}`}
                  onClick={() => handleNameSelect(name)}
                >
                  {name}
                </div>
              ))}
            </div>
          ) : (
            <div className="all-names-list">
              <h4>Common Room Names:</h4>
              <div className="names-grid">
                {predefinedNames.map((name, index) => (
                  <div
                    key={index}
                    className={`name-item ${selectedName === name ? 'selected' : ''}`}
                    onClick={() => handleNameSelect(name)}
                  >
                    {name}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="room-name-buttons">
          <button onClick={handleCancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSave} className="save-btn">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomNameModal; 